import api from './index'
import type { ApiResponse, Project, User } from '@/types'

// 管理員：取得所有專案
export const getAllProjects = async (includeArchived = false): Promise<ApiResponse<{ projects: Project[] }>> => {
  const response = await api.get(`/projects/admin/all?includeArchived=${includeArchived}`)
  return response.data
}

// 管理員：更新專案
export const updateProject = async (
  projectId: string,
  updateData: {
    name?: string
    key?: string
    description?: string
    icon?: string | null
    archived?: boolean
  }
): Promise<ApiResponse<{ project: Project }>> => {
  const response = await api.put(`/projects/admin/${projectId}`, updateData)
  return response.data
}

// 管理員：添加成員到專案
export const addProjectMembers = async (
  projectId: string,
  userIds: string[]
): Promise<ApiResponse<{ project: Project; addedCount: number; skippedCount: number }>> => {
  const response = await api.post(`/projects/admin/${projectId}/members`, { userIds })
  return response.data
}

// 管理員：移除專案成員
export const removeProjectMember = async (
  projectId: string,
  userId: string
): Promise<ApiResponse> => {
  const response = await api.delete(`/projects/admin/${projectId}/members/${userId}`)
  return response.data
}

// 管理員：建立專案
export const createProject = async (
  projectData: {
    name: string
    key: string
    description?: string
    icon?: string | null
  }
): Promise<ApiResponse<{ project: Project }>> => {
  const response = await api.post('/projects', projectData)
  return response.data
}

// 管理員：取得所有使用者
export const getAllUsers = async (): Promise<ApiResponse<{ users: User[] }>> => {
  const response = await api.get('/admin/users')
  return response.data
}

// 管理員：取得預設群組設定
export const getDefaultGroup = async (): Promise<ApiResponse<{ defaultGroup: any; isSet: boolean }>> => {
  const response = await api.get('/admin/default-group')
  return response.data
}

// 管理員：設定預設群組
export const setDefaultGroup = async (groupId?: string): Promise<ApiResponse<{ defaultGroup: any; isSet: boolean }>> => {
  const response = await api.put('/admin/default-group', { groupId })
  return response.data
}
